<ng-container>
  <div *ngIf="!unemployed">
    <app-employer-info [controls]="primaryControls"></app-employer-info>

    <h3 class="text-secondary mt-3">Employer Address</h3>

    <app-address-info [controls]="primaryControls"></app-address-info>
    <app-contact-info [controls]="primaryControls"></app-contact-info>

    <hr class="hr-style" />
  </div>

  <app-employer-payment-info [controls]="primaryControls"
    (changeEvent)="onPayTypeChange($event)"></app-employer-payment-info>

  <app-other-incomes-info [controls]="secondaryControls" (clearEvent)="onClearOtherIncomesClick()"
    (changeEvent)="onOtherIncomeChange($event)"></app-other-incomes-info>
</ng-container>